<template>
  <div>
    <p>Flexbox 也可以制作结尾参差不齐的垂直列</p>
    <p>但它并不那么聪明，因为您需要设置某种高度才能使其包裹列。您还必须明确宽度，而不是让它为您决定列。</p>
    <p>但这是可行的，如果有空间，它会自动调整间隙。</p>
    <div class="masonry">
      <div
        v-for="item in 30"
        :id="item"
        :key="item"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
.masonry {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 1000px;
  div {
    width: 150px;
    background: #EC985A;
    color: white;
    margin: 0 1rem 1rem 0;
    text-align: center;
    font-family: system-ui;
    font-weight: 900;
    font-size: 2rem;
  } 
  @for $i from 1 through 36 { 
    div:nth-child(#{$i}) {
      $h: (random(400) + 100) + px;
      height: $h;
      line-height: $h;
    }
  }
}

</style>